
import { defineComponent, onMounted, reactive, toRefs } from "vue";
import { Viewer } from "photo-sphere-viewer";
import "photo-sphere-viewer/dist/photo-sphere-viewer.css";
import { useRoute } from "vue-router";
import { dataType } from "./vr";

function stateData() {
  return {
    viewer: {},
    imgurl: "",
  };
}

export default defineComponent({
  setup() {
    const state = reactive<dataType>(stateData());
    onMounted(() => {
      const route = useRoute() as any
      state.imgurl = route.query.vrUrl
      state.viewer = new Viewer({
        container: document.querySelector("#viewer"),
        panorama: state.imgurl,
        size: {
          width: "100%",
          height: "100%",
        },
        navbar:['autorotate','fullscreen']
      } as any);
    });
    return {
      ...toRefs(state),
    };
  },
});
